module.exports = __webpack_public_path__ + "img/BlogPost2.189ee66a.jpg";